import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const LandingPage = () => {
    const { signIn, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate('/home/dashboard');
        }
    }, [user, navigate]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col">
            {/* Header */}
            <header className="bg-white shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <div className="flex items-center justify-between">
                        <img src="/church-logo.png" alt="Bethel Church" className="h-12" />
                        <h1 className="text-xl font-semibold text-gray-800">Bethel Forms</h1>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
                <div className="max-w-md w-full">
                    <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                        {/* Logo and Welcome Message */}
                        <div className="text-center space-y-4">
                            <img
                                src="/church-logo.png"
                                alt="Bethel" 
                                className="h-20 w-auto mx-auto"
                            />
                            <div>
                                <h2 className="text-3xl font-bold text-gray-900">
                                    Welcome to Bethel Forms
                                </h2>
                            </div>
                        </div>

                        {/* Features List */}
                        <div className="bg-blue-50 rounded-lg p-4 space-y-2">
                            <h3 className="font-medium text-gray-900 text-sm uppercase tracking-wide">
                                What you can do:
                            </h3>
                            <ul className="text-sm text-gray-700 space-y-1">
                                <li className="flex items-start">
                                    <span className="text-blue-600 mr-2">•</span>
                                    Submit and track form requests
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 mr-2">•</span>
                                    Schedule rooms and resources
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 mr-2">•</span>
                                    Manage purchase orders
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 mr-2">•</span>
                                    Access administrative tools
                                </li>
                            </ul>
                        </div>

                        {/* Login Button */}
                        <div className="pt-4">
                            <div className="text-center text-sm text-gray-600 mb-4">
                                Sign in with your Bethel Google account
                            </div>
                            <div className="flex justify-center">
                                <GoogleLogin
                                    onSuccess={(response) => signIn(response)}
                                    onError={() => console.log("Login Failed")}
                                    useOneTap
                                    theme="outline"
                                    size="large"
                                    shape="pill"
                                    text="continue_with"
                                />
                            </div>
                        </div>

                        {/* Security Notice */}
                        <div className="text-center text-xs text-gray-500 pt-4 border-t">
                            <p>This system is for authorized</p>
                            <p>Bethel Christian School & Church staff only.</p>
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-white border-t">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <p className="text-center text-sm text-gray-500">
                        © {new Date().getFullYear()} Timothy Roe Computer Services, LLC. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
};